import axios from "axios";

const equipmentUrl = "/v2/api/equipment";

class EquipmentService {


    static getEquipmentItemById(equipmentId) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.get(`${equipmentUrl}/${equipmentId}`);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getEquipmentItemBySerialNumber(serialNumber) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.get(`${equipmentUrl}/serial-number/${serialNumber}`);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static getEquipment(options) {
        return new Promise(async (resolve, reject) => {
            try {
                options = options || {};
                console.log(options);

                let url = [
                    equipmentUrl,
                    `?page=${options.currentPage || 1}`,
                    `&limit=${options.pageSize || 50}`,
                    `&orderBy=${options.field || "created_at"}`,
                    `&order=${options.isAsc ? "asc" : "desc"}`,
                    `&expand=owner`,
                ];

                Object.entries(options.filterOptions).map(([key, val]) => {
                    url.push(`&${key}=${val}`);
                });

                url = url.join("");

                let result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static searchEquipment(searchTerm, options) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = [
                    equipmentUrl,
                    `?page=${options.currentPage || 1}`,
                    `&limit=${options.pageSize || 50}`,
                    `&orderBy=${options.field || "created_at"}`,
                    `&order=${options.isAsc ? "asc" : "desc"}`,
                    `&searchTerm=${searchTerm}`,
                    `&expand=owner`,
                ];

                Object.entries(options.filterOptions).map(([key, val]) => {
                    url.push(`&${key}=${val}`);
                });

                url = url.join("");

                let result = await axios.get(url);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static createEquipment(equipmentData) {
        return new Promise(async (resolve, reject) => {
            try {
                const result = await axios.post(equipmentUrl, equipmentData);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static updateEquipment(equipmentId, equipmentData) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.put(`${equipmentUrl}/${equipmentId}`, equipmentData);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }


    static updateLoanStatus(equipmentId, isLoanUnit) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.patch(`${equipmentUrl}/${equipmentId}/update-loan-status`, {isLoanUnit: isLoanUnit});
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static bulkUpdateOperationalStatus(equipmentIds, isOperational) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.patch(`${equipmentUrl}/bulk/operational`, {
                    equipment_ids: equipmentIds,
                    is_operational: isOperational,
                });
                resolve(true);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static updateExpiryDates(equipmentId, expiryDates) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.put(`${equipmentUrl}/${equipmentId}/expiry-dates`, expiryDates);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static createCalibration(equipmentId, calibrationData) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.post(`${equipmentUrl}/${equipmentId}/calibrations`, calibrationData);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static updateCalibration(equipmentId, calibrationId, calibrationData) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.put(`${equipmentUrl}/${equipmentId}/calibrations/${calibrationId}`, calibrationData);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static deleteCalibration(equipmentId, calibrationId) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.delete(`${equipmentUrl}/${equipmentId}/calibrations/${calibrationId}`);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static createContract(equipmentId, contractData) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.post(`${equipmentUrl}/${equipmentId}/contracts`, contractData);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static updateContract(equipmentId, contractId, contractData) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.put(`${equipmentUrl}/${equipmentId}/contracts/${contractId}`, contractData);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

    static deleteContract(equipmentId, contractId) {
        return new Promise(async (resolve, reject) => {
            try {
                let result = await axios.delete(`${equipmentUrl}/${equipmentId}/contracts/${contractId}`);
                resolve(result.data);
            } catch (error) {
                reject(error.response);
            }
        });
    }

}

export default EquipmentService;
